import React, { useEffect } from "react";
import { Box, Container, Flex, Image, Stack, Text } from "@chakra-ui/react";

export default function StrukturOragnisasi() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box mt="65px">
      <Box w="full" h="80" position="relative">
        <Image src="https://saranapatra.com/images/bgBanner.jpg" w="full" h="full" />
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="rgba(10, 60, 126, 0.9)"
        >
          <Stack w="full" h="full" justifyContent="center" alignItems="center">
            <Stack justifyContent="center" alignItems="center" gap="4">
              <Text fontSize="4xl" fontWeight="bold" color="white" textAlign="center">
                Struktur Organisasi
              </Text>
              {/* <Stack direction={{ base: "column", md: "row" }} gap={{ base: 0, md: "4" }}>
              </Stack> */}
            </Stack>
          </Stack>
        </Box>
      </Box>
      <Box bg="gray.50" py="30">
        <Container maxW="6xl">
          <Flex gap="5" direction="column">
            <Text fontSize="30" fontWeight="bold" color="#0A3C7E">
              Struktur Organisasi
            </Text>
            <Text>Struktur Organisasi PT. Sarana Patra Jateng</Text>
          </Flex>
          <Box w="full" minH="600" mt="10">
            <Image
              width="100%"
              height="100%"
              src="https://saranapatra.com/images/diagram-new-cuy.png"
            />
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
